import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';

export default function DocumentNotFound({error}) {
    return (
        <Box component="main" sx={{ p: 2, overflow: 'hidden', maxHeight: '100%', width: '100%' }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2 }}>
                        <Typography variant="h3">{error.status == 404 ? 'Not Found' : 'Unexpected Error'}</Typography>
                        {error.status == 404 ? (
                            <p>This document does not exist, <a href="/literature">click here</a> to return to the home page.</p>
                        ) : (
                            <p>An error occurred opening this document, <a href="/literature">click here</a> to return to the home page.</p>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
}